export const APP_VERSION = process.env.REACT_APP_VERSION || 'VERSION_NOT_SET'